import {AccordionExamples} from './Accordion';
import {BadgeExamples} from './Badge';
import {BannerExamples} from './Banner';
import {BarChartExamples, LineChartExamples} from './Chart';
import {ButtonExamples} from './Button';
import {ButtonGroupExamples} from './ButtonGroup';
import {CheckboxExamples} from './checkbox';
import {ChipExamples} from './Chip';
import {CounterExamples} from './Counter';
import {DateFieldExamples} from './DateField';
import {DividerExamples} from './Divider';
import {DrawerExamples} from './Drawer';
import {FormFieldGroupExamples} from './FormFieldGroup';
import {IconExamples} from './Icon';
import {ImgExamples} from './Img';
import {LinkExamples} from './Link';
import {ListExamples} from './List';
import {MenuExamples} from './Menu';
import {PopoverExamples} from './Popover';
import {RadioExamples} from './radio';
import {SelectExamples} from './select';
import {SpinnerExamples} from './Spinner';
import {SwitchExamples} from './switch';
import {TableExamples} from './Table';
import {TabsExamples} from './tabs';
import {TextFieldExamples} from './textfield';
import {TextareaExamples} from './textarea';
import {TooltipExamples} from './Tooltip';

// NOTE: These tailor component examples are copied to the external
// stripe docs for Tailor UI Toolkit via http://go/sail-next-tailor-docs-publisher

export const tailorComponentExamples = {
  Accordion: AccordionExamples,
  Badge: BadgeExamples,
  Banner: BannerExamples,
  BarChart: BarChartExamples,
  Button: ButtonExamples,
  ButtonGroup: ButtonGroupExamples,
  Checkbox: CheckboxExamples,
  Chip: ChipExamples,
  Counter: CounterExamples,
  DateField: DateFieldExamples,
  Divider: DividerExamples,
  FormFieldGroup: FormFieldGroupExamples,
  Icon: IconExamples,
  Img: ImgExamples,
  LineChart: LineChartExamples,
  Link: LinkExamples,
  List: ListExamples,
  Menu: MenuExamples,
  Radio: RadioExamples,
  Select: SelectExamples,
  Spinner: SpinnerExamples,
  Switch: SwitchExamples,
  Table: TableExamples,
  Tabs: TabsExamples,
  TextArea: TextareaExamples,
  TextField: TextFieldExamples,
  Tooltip: TooltipExamples,
};
export const componentToExamples = {
  ...tailorComponentExamples,
  Drawer: DrawerExamples,
  Popover: PopoverExamples,
};
